// Implements: F-UIX-019, F-GEN-022
/**
 * Mockup v3 P9: the client of `GET /flows`, the generation flows with their current revision and
 * their step roles in order (read-only, any signed-in person). The list is unwrapped from `items`;
 * an answer with no body is broken, never an empty list.
 */

import { API_BASE } from "../../../shared/api/apiBase";
import { httpRequest } from "../../../shared/api/httpClient";
import type { FlowSummaryView, FlowsListView } from "../../../types/reports";

export const FLOWS_PATH = `${API_BASE}/flows`;

export async function fetchFlows(signal?: AbortSignal): Promise<readonly FlowSummaryView[]> {
  const body = await httpRequest<FlowsListView>(FLOWS_PATH, { signal });
  if (body === undefined) throw new Error(`empty answer from ${FLOWS_PATH}`);
  return body.items;
}
